/** Shared hover and stacking classes for calendar blocks. */

/**
 * Hover affordance for any calendar block, cascaded or not. A whole-pixel
 * translate, not a scale: scaling resamples the text at a fractional size, and
 * grows the block on all four sides so a half-covered one bulges out from under
 * its neighbour. Transitions background-color too, for the roster block's tint.
 */
export const BLOCK_HOVER_CLASSES =
  'transition-[transform,box-shadow,background-color] duration-150 hover:-translate-y-0.5 hover:shadow-lg';

/** The block hover plus the emerald ring that marks a shift. */
export const SHIFT_HOVER_CLASSES =
  `${BLOCK_HOVER_CLASSES} hover:ring-2 hover:ring-emerald-400`;

/** Literal class names so Tailwind's scanner emits them. 3 is the clicked block. */
const Z_CLASS: Record<number, string> = { 1: 'z-[1]', 2: 'z-[2]', 3: 'z-[3]' };

/** Stacking for a block that is half of a cascaded overlap; undefined when it owns its column. */
export function cascadeStackClass(
  zIndex: number | undefined,
  isRaised: boolean
): string | undefined {
  return zIndex ? Z_CLASS[isRaised ? 3 : zIndex] : undefined;
}
